import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['offset', 'limit']

  updatePagination(event) {
    Turbolinks.visit(document.location.pathname + "?offset="+ this.offsetTarget.value + "&limit="+ this.limitTarget.value)
  }
}
